import { TRootState } from 'Redux/Reducers';
import { arrayContains } from 'utils';
import Actions from 'Redux/Actions';

export const isPaymentLoading = (state: TRootState): boolean =>
  arrayContains(state.payment.openRequests, [Actions.stripeSetupIntentRequest.type, Actions.confirmPaymentMethodRequest.type]);
